<p-toast [breakpoints]="{'320px': {width: '100%', right: '0', left: '0'}}"></p-toast>
<router-outlet></router-outlet>